import baseTT from 'moodleDir/procollege/lib/vue/default-block-root.vue';

export default {
  routes: [
    {
      path: '/',
      component:baseTT,
      name:'baseTT'
    },
  ]
};
